import { motion } from "framer-motion";
import StoreBadges from "./StoreBadges";
import SocialProof from "./SocialProof";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-40 sm:pt-48 pb-24 sm:pb-32 overflow-hidden"
    >
      {/* Ambient glows */}
      <div
        aria-hidden="true"
        className="absolute top-24 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[#9D4CDD]/25 blur-[140px] animate-glow-pulse"
      />
      <div
        aria-hidden="true"
        className="absolute top-60 right-[10%] w-[300px] h-[300px] rounded-full bg-[#B47CE8]/20 blur-[100px]"
      />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col items-center text-center max-w-4xl mx-auto"
        >
          <motion.span
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass text-xs sm:text-sm text-white/80 font-medium mb-8"
            data-testid="hero-badge"
          >
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#B47CE8] opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#9D4CDD]"></span>
            </span>
            Nouvelle version disponible
          </motion.span>

          <h1
            data-testid="hero-title"
            className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold tracking-tighter text-white leading-[0.95] mb-6"
          >
            Glow Up
            <br />
            <span className="bg-gradient-to-br from-[#E9D5FF] via-[#B47CE8] to-[#9D4CDD] bg-clip-text text-transparent">
              Mentalement
            </span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="text-lg sm:text-xl md:text-2xl text-white/70 max-w-2xl leading-relaxed font-medium mb-10"
          >
            Avec Echo, l&apos;application française nº1 de glow up mental.
          </p>

          <StoreBadges testidPrefix="hero" className="mb-6" />
          <SocialProof testid="hero-social-proof" />
        </motion.div>
      </div>
    </section>
  );
}
